import {ReactNode} from "react";
import {Box, HStack, Text} from "@chakra-ui/react";
import {DisclosureChecklistCounts} from "platformed-client/types";
import T from "platformed-components/i18n/T";
import {MultiProgressBar} from "../../../../../components/ui/progress";

type ProgressCounts = Pick<
  DisclosureChecklistCounts,
  "reviewable" | "signed_off" | "reviewed" | "exceptions" | "blocked"
>;

const pct = (n: number, of: number) => (of > 0 ? (n / of) * 100 : 0);

export const Metric = ({color, n, children}: {color: string; n: number; children: ReactNode}) =>
  n > 0 ? (
    <HStack gap={1.5}>
      <Box boxSize="0.625rem" rounded="full" bg={color} />
      <Text fontSize="sm" color="fg.muted">
        {children}
      </Text>
    </HStack>
  ) : null;

export const ChecklistProgress = ({counts}: {counts: ProgressCounts}) => (
  <>
    <MultiProgressBar
      segments={[
        {percentage: pct(counts.reviewed, counts.reviewable), color: "green.500"},
        {percentage: pct(counts.exceptions, counts.reviewable), color: "orange.500"},
        {percentage: pct(counts.blocked, counts.reviewable), color: "red.500"},
      ]}
      height="0.5rem"
      borderRadius="full"
    />
    <HStack gap={4} mt={2.5} flexWrap="wrap">
      <Text fontSize="sm" color="fg.muted">
        <T keyName="c.reviewed_of_total[parameterized]" params={{count: counts.signed_off, total: counts.reviewable}} />
      </Text>
      <Metric color="orange.500" n={counts.exceptions}>
        <T keyName="c.exceptions[enumerated]" params={{count: counts.exceptions}} />
      </Metric>
      <Metric color="red.500" n={counts.blocked}>
        <T keyName="c.blocked[enumerated]" params={{count: counts.blocked}} />
      </Metric>
    </HStack>
  </>
);
